module.exports = __webpack_public_path__ + "img/fpb-branco.e0ee2c9a.svg";